import { Table, Box, Avatar, Typography, InputLabel } from "@mui/material";
import React from "react";
import { StyledTableCell, StyledTableRow } from "../../Common/StyledCell";
import EmptyData from "../../Common/EmptyData";

const Sellers = ({ data = [] }) => {

  console.log(data)
  return (
    <>
      <Table>
        {!data || data?.length === 0 ? (
          <>
            <EmptyData label="No Data available currently" height="400px" />
          </>
        ) : (
          <>
            {data?.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: 2,
                      width: "70%",
                    }}
                  >
                  <div>

                   <Avatar src={item?.seller?.imageUrl || ""} sx={{borderRadius:'4px'}} alt="" width={30}/>
                  </div>
                    <Box>
                      <InputLabel
                        sx={{
                          fontFamily: "Lato",
                          fontWeight: 500,
                         
                        
                        }}
                      >
                        {`${item?.seller?.firstName} ${item?.seller?.firstName}` || ""}
                      </InputLabel>
                    <Typography sx={{fontSize:'12px'}}>${item?.totalAmount?.toLocaleString()}</Typography>
                    </Box>
                  </Box>
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.totalOrders} Orders
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </>
        )}
      </Table>
    </>
  );
};

export default Sellers;
